import { QueryList } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { PottingInstructionsFormComponent } from "./potting-instructions-form/potting-instructions-form.component";
import { asEnumerable } from "linq-es2015";
var PottingInstructionsComponent = /** @class */ (function () {
    function PottingInstructionsComponent() {
    }
    PottingInstructionsComponent.prototype.ngOnInit = function () {
        var potTypes = asEnumerable(this.ceRequestOptions.potTypes)
            .Where(function (s) { return s.isActive; })
            .OrderBy(function (s) { return s.name; })
            .Select(function (s) {
            return {
                id: s.id,
                display: s.name
            };
        })
            .ToArray();
        var substrates = asEnumerable(this.ceRequestOptions.substrates)
            .Where(function (s) { return s.isActive; })
            .OrderBy(function (s) { return s.requiresFollowup; })
            .ThenBy(function (s) { return s.name; })
            .Select(function (s) {
            return {
                id: s.id,
                display: s.name
            };
        })
            .ToArray();
        var irrigations = asEnumerable(this.ceRequestOptions.irrigations)
            .Where(function (s) { return s.isActive; })
            .OrderBy(function (s) { return s.requiresFollowup; })
            .ThenBy(function (s) { return s.name; })
            .Select(function (s) {
            return {
                id: s.id,
                display: s.name
            };
        })
            .ToArray();
        var fertigations = asEnumerable(this.ceRequestOptions.fertigations)
            .Where(function (s) { return s.isActive; })
            .OrderBy(function (s) { return s.requiresFollowup; })
            .ThenBy(function (s) { return s.name; })
            .Select(function (s) {
            return {
                id: s.id,
                display: s.name
            };
        })
            .ToArray();
        this.pottingInstructionsOptions = {
            potTypes: potTypes,
            substrates: substrates,
            irrigations: irrigations,
            fertigations: fertigations
        };
    };
    Object.defineProperty(PottingInstructionsComponent.prototype, "treatments", {
        get: function () {
            return this.experimentDesignFormGroup.get("treatments");
        },
        enumerable: true,
        configurable: true
    });
    PottingInstructionsComponent.prototype.applyAll = function (sourceComponent) {
        var args = {
            potType: sourceComponent.potType,
            substrate: sourceComponent.substrate,
            irrigation: sourceComponent.irrigation,
            fertigation: sourceComponent.fertigation
        };
        this.pottingInstructionForms.forEach(function (f) { return f.copyValueFrom(args); });
    };
    return PottingInstructionsComponent;
}());
export { PottingInstructionsComponent };



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/request-creation/experiment-design/potting-instructions/potting-instructions.component.ts.pre-build-optimizer.js